module.exports = __webpack_public_path__ + "static/img/008.5b86ad2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fushen/008.png
// module id = pkJX
// module chunks = 0